import { Phone } from "components/phone-number/PhoneNumber";
import { QuickPayMode } from "./ISite";

export interface ICreditData {
    cardType: string;
    funding: string;
    lastFour: string;
    overrideFeePercent?: number;
    overrideFeeFlat?: number;
}

export interface IAccountDetail {
    primaryReference?: any;
    customFields?: [];
}

export interface IJudoPayCardDetails {
    cardType?: string;
    funding?: string;
    lastFour?: string;
    cardHolderName?: string;
    isCardAccepted?: boolean;
    cardCheckError?: string;
    isCorporate?: boolean;
}

export interface ICardFee {
    cardType: string;
    flatFee: number;
    percentageFee: number;
}

export interface IPaymentRefernces {
    judoPaymentReference?: string;
    internalPaymentReference?: string;
    cardToken?: string;
}

export enum PaymentStep {
    CustomerDetails = 1,
    CardDetails = 2,
    PaymentCompletion = 3,
}

export interface IPersonalData {
    name?: string;
    address?: string;
    email?: string;
    phone?: Phone;
    postal?: string;
    notes?: string;
    dateOfBirth?: string;

    accountHolderSurnameOrCompanyName?: string;
    isCompany?: boolean;

    payeeCustom1?: string;
    payeeCustom2?: string;
    payeeCustom3?: string;

    accountDetails?: IAccountDetail;
}

export enum PaymentType {
    Single = 0,
}

export interface IPaymentData {
    totalDebt?: number;
    paymentType: PaymentType;
    singlePaymentAmount?: number;
    paymentFutureDate?: string;
    futureDatePaymentAmount?: number;
    futureDatePaymentSetupAmount?: number;
}

export default interface IPayment {
    personalData?: IPersonalData;
    creditData?: ICreditData;
    paymentData: IPaymentData;
    sendQuickPay?: QuickPayMode;
    total?: number;
}

export interface ICheckCard {
    tempPaymentCreateUrl: string;
    updateSaveCardUrl: string;
    lookupCardFeeUrl: string;
    paymentPayload: IPayment;
}

export interface ICompletePayment {
    paymentPayload: ICompletePaymentPayload;
    createPaymentUrl: string;
    returnUrl: string;
}

export interface IPaymentState {
    paymentReferences?: IPaymentRefernces;
    cardFee?: ICardFee;
    paymentStep: PaymentStep;
    paymentCard: IJudoPayCardDetails;
    isProcessing: boolean;
}

export interface IPaymentResponse {
    transactionId: number;
    reference: string;
    paymentReference: string;
    cardToken: string;
}

export interface ICompletePaymentPayload {
    payment: IPayment;
    paymentReferences?: IPaymentRefernces;
    paymentCard?: IJudoPayCardDetails;
}

export interface IQuickPayFile {
    file: string;
}
